// Strips the `token` query param (the tarjouspyyntö preview page's capability
// token, e.g. /tarjouspyynnot/esikatselu?token=<jwt>) from a URL-shaped string
// before it leaves the browser. That token grants read access on its own, so
// it must never reach GA4 (src/analytics/gtag.js) or Sentry (src/sentry.js).
export function scrubToken(value) {
    if (!value) return value;
    try {
        const wasAbsolute = /^[a-z][a-z0-9+.-]*:\/\//i.test(value);
        const url = new URL(value, wasAbsolute ? undefined : "https://scrub.invalid");
        if (!url.searchParams.has("token")) return value;
        url.searchParams.delete("token");
        // Preserve the caller's shape: a relative page_path in stays relative.
        return wasAbsolute ? url.toString() : `${url.pathname}${url.search}${url.hash}`;
    } catch {
        // Input the URL constructor can't parse (rare) — regex fallback.
        return value.replace(/([?&])token=[^&#]*&?/, "$1").replace(/[?&]$/, "");
    }
}
